/* global dataLayer */
const optimizely = window.optimizely || [];
const datadog = window.DD_RUM || null;
const ga = window.ga || null;

const formAnalytics = {
  setOptimizelyEvents(prefix, event, postfix) {
    if (!prefix) return;
    const optimizelyMessage = postfix
      ? `${prefix}-${event}-${postfix}`
      : `${prefix}-${event}`;
    optimizely.push(['trackEvent', optimizelyMessage]);
  },

  optimizelyXEvent(eventName) {
    optimizely.push({
      type: 'event',
      eventName
    });
  },

  siteEvent(category, label, action) {
    if (datadog) {
      datadog.addAction(`${category}: ${label}: ${action}`);
    }
    if (ga) {
      ga('send', 'event', category, action, label);
    }
  },

  siteEventWithData(category, label, data) {
    if (datadog) {
      datadog.addAction(`${category}: ${label}`, data);
    }
  },

  sendSteps(step, steps, fieldValue, prefix, gaPrefix) {
    const formAction = step < steps ? 'Click' : 'Submit';
    const formStep = step;
    const gaEventType = steps > 1 ? 'PSG' : 'webForm';
    const gaEvent = gaPrefix ? `${gaPrefix}${gaEventType}` : gaEventType;
    dataLayer.push({ event: gaEvent, formAction, fieldValue, formStep });

    if (!prefix) return;
    let optimizelyMessage = `${prefix}-`;
    optimizelyMessage +=
      step >= steps ? 'POSG-Results' : `POSG-Step${step}complete`;
    optimizely.push(['trackEvent', optimizelyMessage]);
  },

  sendErrors(invalidMarketo, invalidMessage, currentStep, totalSteps, prefix) {
    const fullPrefix = prefix ? `${prefix}PSG` : 'PSG';
    const formAction = 'Error';
    const fieldName = invalidMarketo
      .replace(/__c$/, '')
      .replace(/[^a-zA-Z ]+/g, ' ');
    if (totalSteps > 1) {
      dataLayer.push({
        event: fullPrefix,
        formAction,
        fieldName,
        invalidMessage,
        currentStep
      });
    } else {
      dataLayer.push({
        event: 'webForm',
        formAction,
        fieldName,
        invalidMessage
      });
    }
  },

  setVirtualThankYouPage() {
    dataLayer.push({
      event: 'vpConfirmation',
      virtualPageUrl: '/thank-you-confirmation',
      virtualPageTitle: 'Thank You | ShopKeep'
    });
  }
};

export default formAnalytics;
